import React from 'react';

import CameraIcon from '../Icons/Photo.svg';

const Attachment = ({ question }) => {

  const itemControl = question.extension.find((extension) => {
    return extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl';
  });

  return <>
    <h6 className="card-title">{question.text || 'Enter your question.'}</h6>

    {!itemControl &&
      <input type="file" className="form-control" />
    }

    {itemControl.valueCodeableConcept.coding[0].code === 'photo' &&
      <div className="shadow-none p-3 bg-light rounded row">
        <div className="col">
          <img width={20} src={CameraIcon} alt="Camera Icon" />
        </div>
        <div className="col-10">
          Take Photo or Gallery
        </div>
      </div>
    }

  </>;
}

export default Attachment;